import React from "react";
import ReactDOM from "react-dom";

// @ts-ignore
import { ThroughProvider } from "react-through";
import App from "./App";
import { i18nReady } from "./core/i18n/i18n";
import "./index.css";
import * as serviceWorker from "./serviceWorker";

const TheApp = () => (
  <ThroughProvider>
    <App />
  </ThroughProvider>
);

i18nReady.then(() => {
  ReactDOM.render(<TheApp />, document.getElementById("root"));
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
